import { render, staticRenderFns } from "./NewAsset.vue?vue&type=template&id=30a56a26"
import script from "./NewAsset.vue?vue&type=script&lang=js"
export * from "./NewAsset.vue?vue&type=script&lang=js"
import style0 from "./NewAsset.vue?vue&type=style&index=0&id=30a56a26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports